import axios from 'axios'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import { CategoryContext } from '../../context api/Category/CategoryContext'
import { ProductContext } from '../../context api/Product/ProductContext'
import { SubCategoryContext } from '../../context api/SubCategory/SubCategoryContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'
import { useCompanyAdmin } from '../CompanyAdmin/useCompanyAdmin'
import urlSearchParams from '../../components/urlSearchParams'

export const useFeatures = (handleNext) => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [subCategory, setSubCategory] = useState(false)
  const [category, setCategory] = useState(false)
  const [lead, setLead] = useState(false)
  const [leadStatus, setLeadStatus] = useState(false)
  const [zoneCount, setZoneCount] = useState(false)
  const [highestLead, setHighestLead] = useState(false)
  const [leadAmount, setLeadAmount] = useState(-1)
  const [loading, setLoading] = useState(false)
  const [ allowanceTypes, setAllowanceTypes ] = useState([]);
  const [ supervisorRequests, setSupervisorRequests ] = useState([]);
  const { getNewCategories, addNewCategory, editNewCategory, deleteNewCategory } = useContext(CategoryContext)
  const { getNewSubCategories, addNewSubCategory, editNewSubCategory, deleteNewSubCategory } = useContext(SubCategoryContext)
  const { getNewProducts, addNewProduct, editNewProduct, deleteNewProduct } = useContext(ProductContext)
  const [attendances, setAttendances] = useState({
    loading: false,
    allAttendance: false,
    pagination: false,
  })
  const [travelCategories, setTravelCategories] = useState([])
  const [leaves, setLeaves] = useState({
    loading: false,
    allLeaves: false,
  })
  const [products, setProducts] = useState([])

  const [leads, setLeads] = useState({
    loading: false,
    allLeads: false,
  })
  const [positions, setPositions] = useState([])

  const addPosition = async (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_POSITION, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }

        localStorage.setItem('positionId', data.position._id)
        toastMessage('Position Added Successfully', success)
        handleNext()
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const linkLocation = async (dto) => {
    setLoading(true)
    axios
      .put(API.LINK_LOCATION, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }

        // localStorage.setItem('positionId', data.position._id)
        // toastMessage('Location Linked Successfully', success)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const linkKyc = async (dto) => {
    setLoading(true)
    axios
      .put(API.LINK_KYC, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }

        // localStorage.setItem('positionId', data.position._id)
        toastMessage('Kyc Linked Successfully', success)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const addLocation = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_LOCATION, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        linkLocation({ locationId: data.location._id, employeeId: localStorage.getItem('employeeId') })
        toastMessage('Location Added Successfully', success)
        // localStorage.removeItem('employeeId')
        handleNext(true)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }
  const updateLocation = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_LOCATION, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }

        toastMessage('Location Updated Successfully', success)
        // localStorage.removeItem('employeeId')
        handleNext(true)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const addKYC = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_KYC, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Kyc Added Successfully', success)
        linkKyc({ kycId: data.kyc._id, employeeId: localStorage.getItem('employeeId') })
        localStorage.removeItem('employeeId')
        history.push(ROUTES.ALL_EMPLOYEES)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }
  const updateKYC = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_KYC, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Kyc Updated Successfully', success)

        // history.push(ROUTES.ALL_EMPLOYEES)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getBelowEmployeeAttendance = (page) => {
    setLoading(true)
    setAttendances({ ...attendances, allAttendance: false, loading: true, pagination: false })

    axios
      .get(API.GET_BELOW_EMPLOYEE_ATTENDANCE(page), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setLoading(false)
        // if (data.USR) {
        setAttendances({
          ...attendances,
          allAttendance: data.USR ? data.USR : false,
          loading: false,
          pagination: data.totalPage,
          attendanceRecord: data.attendanceRecord,
        })
        // }
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAllPositions = (dto) => {
    setLoading(true)
    axios
      .post(API.GET_ALL_POSITIONS, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setPositions(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const updateAttendanceByAdmin = (dto) => {
    setLoading(true)
    axios
      .put(API.UPDATE_ATTENDANCE_BY_ADMIN, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Somethi\ng Went Wrong !', error)
        }

        history.push(ROUTES.ALL_ATTENDANCE)
        // setAttendances(false)
        if (data.data) {
          localStorage.setItem('refreshAttendance', true)
          toastMessage('Attendance Updated Successfully', success)

          // return getBelowEmployeeAttendance()
        }
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  // const getBelowEmployeeLeaves = () => {
  //   setLeaves({ ...leaves, allLeaves: false, loading: true })

  //   axios
  //     .get(API.GET_BELOW_EMPLOYEE_LEAVES, header)
  //     .then(({ status, data }) => {
  //       //console.log('DATA : ', data)
  //       if (status !== 200) {
  //         return toastMessage('Something Went Wrong !', error)
  //       }

  //       setLeaves({
  //         ...leaves,
  //         allLeaves: data.USR ? data.USR : false,
  //         loading: false,
  //         mix: {
  //           total: data.total,
  //           accepted: data.acceptedLeaves,
  //           rejected: data.rejectedLeaves,
  //           pending: data.pendingLeaves,
  //         },
  //       })
  //     })
  //     .catch((err) => {
  //       if (err.response) {
  //         //console.log(err.response)
  //         return toastMessage(err.response.data.error, error)
  //       }
  //     })
  // }

  // const approveLeave = (dto) => {
  //   //console.log('DTO : ', dto)
  //   axios
  //     .post(API.APPROVE_LEAVE, dto, header)
  //     .then(({ status, data }) => {
  //       //console.log('DATA : ', data)
  //       if (status !== 201) {
  //         return toastMessage('Something Went Wrong !', error)
  //       }

  //       // setLeaves(data.USR)
  //       if (data.lev.leaveApproved === 'APPROVED') {
  //         toastMessage('Leave Approved...!', success)
  //       }
  //       if (data.lev.leaveApproved === 'REJECTED') {
  //         // toastMessage('Leave Approved...!', success)
  //         toastMessage('Leave Rejected...!', success)
  //       }

  //       getBelowEmployeeLeaves()
  //     })
  //     .catch((err) => {
  //       if (err.response) {
  //         //console.log(err.response)
  //         return toastMessage(err.response.data.error, error)
  //       }
  //     })
  // }

  //PRODUCTS
  const getAllProducts = (page) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_PRODUCTS(page), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        // setProducts(data.product)
        getNewProducts(data.product ? data.product : [], data.totalPage)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const addProduct = async (data) => {
    setLoading(true)
    axios
      .post(API.ADD_PRODUCT, data, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Product Added Successfully', success)
        history.push(ROUTES.PRODUCTS)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const editProduct = async (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_PRODUCT, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Product Updated Successfully', success)
        history.push(ROUTES.PRODUCTS)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const deleteProduct = async (dto) => {
    setLoading(true)
    axios
      .post(API.DELETE_PRODUCT, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Product Deleted Successfully', success)
        // handleNext()
        deleteNewProduct(dto.productId)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  //LEADS
  const getAllLeads = (dto = {}) => {
    setLoading(true)
    setLeads({ ...leads, allLeads: false, loading: true })

    axios
      .get(API.GET_ALL_LEADS(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        // setLeads(data.LeadH)
        setLeads({ ...leads, allLeads: data.LeadH ? data.LeadH : [], loading: false })
        setLeadStatus(data.count ? data.count : [])
        setZoneCount(data.countZone ? data.countZone : [])
        // setHighestLead(data.countZone)
        setHighestLead(data.LeadHighest ? data.LeadHighest : [])
        setLeadAmount(data.leadAmount ? data.leadAmount : 0)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getLead = (dto) => {
    setLoading(true)
    axios
      .post(API.GET_LEAD, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setLead(data.data)
        // setLeads(data.LeadH)
        // setLeads({ ...leads, allLeads: data.LeadH ? data.LeadH : false, loading: false, leadStatus: data.leadStatus })
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  //SUB CATEGORY
  const getAllsubCategory = () => {
    setLoading(true)
    axios
      .get(API.GET_ALL_SUBCATEGORIES, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        getNewSubCategories(data.data ? data.data : [])
        // setSubCategories(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAllsubCategoryByCategory = (dto) => {
    setLoading(true)
    axios
      .post(API.GET_ALL_SUBCATEGORIES_BY_CATEGORY, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        getNewSubCategories(data.data)
        // setSubCategories(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getSubCategory = (dto) => {
    setLoading(true)
    axios
      .post(API.GET_SUBCATEGORY, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setSubCategory(data.data)
        // setSubCategories(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const addsubCategory = async (data) => {
    setLoading(true)
    axios
      .post(API.ADD_SUBCATEGORY, data, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('SubCategory Added Successfully', success)
        history.push(ROUTES.SUBCATEGORIES)
        // addNewSubCategory(data.data)
        // setLoading(true)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const updatesubCategory = async (data) => {
    setLoading(true)
    axios
      .put(API.EDIT_SUBCATEGORY, data, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('SubCategory Updated Successfully', success)

        history.push(ROUTES.SUBCATEGORIES)

        // return getAllsubCategory()
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const deletesubCategory = async (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_SUBCATEGORY, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('SubCategory Deleted Successfully', success)
        deleteNewSubCategory(dto.subcategoryId)
        // setLoading(true)
        setSelected([])
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const deleteManySubCategory = async (dto, setSelected) => {
    setLoading(true)
    //console.log('DTO : ', dto)
    axios
      .post(API.DELETE_MANY_SUBCATEGORY, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.subcategoryId.length} SubCategory Deleted Successfully`, success)

        dto.subcategoryId.map((item) => deleteNewSubCategory(item))
        setSelected([])
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const BulkUpload = async (data, sheetName) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, data, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        bulkUploadPopup(data, addNewSubCategory)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const BulkUploadSubCategory = async (data, sheetName) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD_SUBCATEGORY, data, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        // toastMessage('SubCategory Uploaded Successfully', success)
        // data.data.map((item) => addNewSubCategory(item))
        bulkUploadPopup(data, addNewSubCategory)
        getAllsubCategory()
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const BulkUploadProduct = async (data, sheetName) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD_PRODUCT, data, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        data.data.map((item) => addNewProduct(item))
        toastMessage('Product Uploaded Successfully', success)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getTravelCat = (dto= {}) => {
    setLoading(true)
    axios
      .get(API.TRAVEL_CATEGORY(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setLoading(false)
        // if (data.USR) {
        setTravelCategories(data.data);
        // }
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAllowanceTypes = (dto= {}) => {
    setLoading(true)
    axios
      .get(API.ALLOWANCE_TYPES(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setLoading(false)
        // if (data.USR) {
        setAllowanceTypes(data.data);
        // }
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAllowanceRequestForSupervisor = (dto= {}) => {
    setLoading(true)
    axios
      .get(API.ALLOWANCE_REQUESTS_SUPERVISOR(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setLoading(false)
        // if (data.USR) {
        setSupervisorRequests(data);
        // }
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  // const deleteCats = (dto, setSelected) => {
  //   setLoading(true)
  //   axios
  //     .get(API.DELETE_ALLOWANCE(urlSearchParams(dto)), header)
  //     .then(({ status, data }) => {
  //       //console.log('DATA : ', data)
  //       if (status !== 200) {
  //         return toastMessage('Something Went Wrong !', error)
  //       }
  //       setLoading(false)
  //       // if (data.USR) {
  //       setTravelCategories(data.data);
  //       // }
  //     })
  //     .catch((err) => {
  //       setLoading(false)
  //       if (err.response) {
  //         //console.log(err.response)
  //         return toastMessage(err.response.data.error, error)
  //       }
  //     })
  // }
  // const deleteManyCats = (dto, setSelected) => {
  //   setLoading(true)
  //   axios
  //     .get(API.TRAVEL_CATEGORY(urlSearchParams(dto)), header)
  //     .then(({ status, data }) => {
  //       //console.log('DATA : ', data)
  //       if (status !== 200) {
  //         return toastMessage('Something Went Wrong !', error)
  //       }
  //       setLoading(false)
  //       // if (data.USR) {
  //       setTravelCategories(data.data);
  //       // }
  //     })
  //     .catch((err) => {
  //       setLoading(false)
  //       if (err.response) {
  //         //console.log(err.response)
  //         return toastMessage(err.response.data.error, error)
  //       }
  //     })
  // }
  return {
    BulkUpload,
    BulkUploadSubCategory,
    BulkUploadProduct,
    deletesubCategory,
    getAllsubCategory,
    addsubCategory,
    updatesubCategory,
    // subCategories,
    addPosition,
    addLocation,
    attendances,
    getBelowEmployeeAttendance,
    leaves,
    // getBelowEmployeeLeaves,
    // approveLeave,
    products,
    getAllProducts,
    addProduct,
    // getAllCategories,
    deleteProduct,
    // updateCategory,
    loading,
    // setLoading,
    editProduct,
    // addCategory,
    updateAttendanceByAdmin,
    leads,
    getAllLeads,
    positions,
    addKYC,
    getAllPositions,
    // deleteCategory,
    getAllsubCategoryByCategory,
    getSubCategory,
    subCategory,
    category,
    // getCategory,
    // deleteManyCategory,
    updateLocation,
    updateKYC,
    getLead,
    lead,
    deleteManySubCategory,
    leadStatus,
    zoneCount,
    highestLead,
    leadAmount,
    getTravelCat,
    travelCategories,
    getAllowanceTypes,
    allowanceTypes,
    getAllowanceRequestForSupervisor,
    supervisorRequests,
    setSupervisorRequests,
  }
}
